// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nD5w","largestCol":"styles_largestCol__mxG7i","smallestCol":"styles_smallestCol__24VJX"};